import FactorHealthBadge from './FactorHealthBadge'
import * as constants from './factor-health-badge-constants'
import reducer from './factor-health-badge-reducer'

export {constants, reducer, FactorHealthBadge}
export default FactorHealthBadge
